<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from '@/components/page-header-custom.vue';
//const parsePhoneNumber = require("awesome-phonenumber").parsePhoneNumber;
import ImageUploader from "../../../../components/ImageUploader.vue";
import ProfileImageUploader from "../../../../components/ProfileImageUploader.vue";
import { Storage } from 'aws-amplify';
import store from "@/state/store";
const parsePhoneNumber = require("awesome-phonenumber").parsePhoneNumber;
import {
  authComputed,
  authMethods,
  addressComputed,
  addressMethods,
  profileMethods, 
  profileComputed,
//   rolesMethods,
//   rolesComputed,
  layoutMethods,
  layoutComputed
} from "@/state/helpers";

export default {
    data() {
        return {
            title: "User Profile",
            items: [
                {
                    text: "Profile",
                },
            ],
            preloadProfileImageKey: 0,
            isPageReloading: true,
            customRoleList: [],
            user: {
                name: null,
                roleId: null,
                roleName: null,
                email: null,
                phone_number: null,
                phone_number_checker: null,
                password: null,
                confirmPassword: null,
                profileImageKey: null,
                profileSrc: require('@/assets/images/img-profile-placeholder.png'),
                logo: {
                    filename: null,
                    type: null,
                    base64: null,
                }
            },
            showTimers: false,
            bizTypeOption: {
                others: false,
                value: null
            },
            organization: {
                businessType: null,
                businessHours: null,
                startHour: null,
                endHour: null,
                logoKey: null,
                logoSrc: require('@/assets/images/img-placeholder.png'),
                logo: {
                    filename: null,
                    type: null,
                    base64: null,
                },
                name: null,
                contact_number: null,
            },
            address: {
                countryId: null,
                countryIso: 'PHL',
                countryIso3: 'PH',
                street: null,
                barangayId: null,
                cityId: null,
                provinceId: null,
                regionId: null,
            },
            regionsData: [],
            citiesData: [],
            barangaysData: [],
            provincesData: [],
            businessTypeOptions: [
                { text: "Select Business Type", value: null },
                { text: "Retailers", value: "Retailers" },
                { text: "Grocery", value: "Grocery" },
                { text: "Restaurant", value: "Restaurant" },
                { text: "Café", value: "Café" },
                { text: "Fast Food Chain", value: "Fast Food Chain" },
                { text: "Online Food Seller", value: "Online Food Seller" },
                { text: "Services", value: "Services" },
                { text: "Others", value: "Others" },
            ],
        };
    },
    computed: {
        ...profileComputed,
        ...authComputed,
        ...addressComputed,
        // ...rolesComputed,
        ...layoutComputed,
        dynMobileRule() {
            // return `dyn-mobile:${this.address.countryIso3}`;
            return '';
        },
        countryOptions() {
            return [{
                    text: "Select Country",
                    value: null
                },
                ...this.countries.map((r) =>
                    Object.assign({}, {
                        text: r.countryName,
                        value: r.countryId
                    })
                ),
            ];
        },
        roleOptions() {
            return [{
                    text: "Select Role",
                    value: null
                },
                ...this.customRoleList.map((r) =>
                    Object.assign({}, {
                        text: r.name,
                        value: r.id
                    })
                ),
            ];
        },
        regionOptions() {
            if(this.regionsData == null) return [{text: "Select Region", value: null}];
            return [{
                    text: "Select Region",
                    value: null
                },
                ...this.regionsData.map((r) =>
                    Object.assign({}, {
                        text: r.regionName,
                        value: r.regionId
                    })
                ),
            ];
        },
        provinceOptions() {
            if(this.provincesData == null) return [{text: "Select Province", value: null}];
            return [
                { text: "Select Province", value: null },
                ...this.provincesData.map((p) =>
                Object.assign({}, { text: p.provinceName, value: p.provinceId })
                ),
            ];
        },
        cityOptions() {
            if(this.citiesData == null) return [{text: "Select City", value: null}];
            return [
                { text: "Select City", value: null },
                ...this.citiesData.map((c) =>
                Object.assign({}, { text: c.cityName, value: c.cityId })
                ),
            ];
        },
        barangayOptions() {
            if(this.barangaysData == null) return [{text: "Select Barangay", value: null}];
            return [
                { text: "Select Barangay", value: null },
                ...this.barangaysData.map((b) =>
                Object.assign({}, { text: b.brgyName, value: b.brgyId })
                ),
            ];
        },
    },
    watch: {
        
        'organization.startHour': 'updateBusinessHours',
        'organization.endHour': 'updateBusinessHours',
        'bizTypeOption.value' : {
            handler(value) {
                this.bizTypeOption.others = (value == 'Others');
            },
            immediate: true,
        }
        // 'user.phone_number': {
        //     handler() {
        //         // Call a method to reformat the phone number based on the new country code
        //         this.updateUserPhoneNumberFormat();
        //     },
        //     immediate: true,
        // },
        // 'organization.contact_number': {
        //     handler() {
        //             // Call a method to reformat the phone number based on the new country code
        //             this.updateBizPhoneNumberFormat();
        //         },
        //         immediate: true,
        //     },
        
        
    },
    methods: {
        ...profileMethods,
        ...authMethods,
        ...addressMethods,
        // ...rolesMethods,
        ...layoutMethods,
        updateUserPhoneNumberFormat() {
            if(this.user.phone_number)
            {
                const pn = parsePhoneNumber(this.user.phone_number, {
                    regionCode: this.address.countryIso,
                });
                if (pn.number.international) {
                    this.user.phone_number = pn.number.international.replace(/\s/g, "");
                }
            }
        },
        updateBizPhoneNumberFormat() {
            if(this.organization.contact_number)
            {
                const pn = parsePhoneNumber(this.organization.contact_number, {
                    regionCode: this.address.countryIso,
                });
                if (pn.number.international) {
                    this.organization.contact_number = pn.number.international.replace(/\s/g, "");
                }
            }
           
        },
        formatTime(time) 
        {
            // Add AM or PM to the time value if it's in 12-hour format
            if(time != null)
            {
                const timeParts = time.split(':');
                let hour = parseInt(timeParts[0]);
                const minute = timeParts[1];

                const isAM = hour < 12;
                if (hour === 0) {
                    hour = 12; // 12:00 AM should be displayed as 12:00 AM, not 00:00 AM
                } else if (hour > 12) {
                    hour -= 12;
                }

                const period = isAM ? 'AM' : 'PM';
                return `${hour}:${minute} ${period}`;
            }
            return `00:00 AM`;
            
        },
        updateBusinessHours() {
            // Update the businessHours value based on the opening and closing timers
            const startHourFormatted = this.organization.startHour != null ? this.formatTime(this.organization.startHour) : this.formatTime('00:00');
            const endHourFormatted = this.organization.endHour != null ? this.formatTime(this.organization.endHour) : this.formatTime('00:00');
            this.organization.businessHours = `${startHourFormatted} - ${endHourFormatted}`;
        },
         onBusinessHoursFocusOut(event) {
            const timersRow = document.querySelector('.biz-timer-class');
            if (!timersRow.contains(event.relatedTarget)) {
                this.showTimers = false;
            }
        },

        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        async getRegions() {
            if(this.user.roleName != 'Super Admin') return;
            this.address.countryIso = this.address.countryIso != null && this.address.countryIso != '' ? (this.countries.find((country) => country.countryId === this.address.countryId)).iso : 'PH'
            this.address.countryIso3 = this.address.countryIso != null && this.address.countryIso != '' ? (this.countries.find((country) => country.countryId === this.address.countryId)).iso3 : 'PHL'
            if(this.organization.contact_number) this.$refs.orgMobileNumber.validate(); // revalidate the fields
            this.$refs.userMobileNumber.validate(); // revalidate the fields
            if(this.address.countryId == 169)
            {
                await this.fetchRegions({
                    storeCount: 0
                }).then(data => {
                    this.regionsData = data;
                });
            }
            else {
                
                this.address.regionId = null;
                this.regionsData = null;
                this.address.cityId = null;
                this.citiesData = null;
                this.address.provinceId = null;
                this.provincesData = null;
                this.address.barangayId = null;
                this.barangaysData = null;
                
                setTimeout(() => {
                    this.$refs.addressRegion.reset();
                    this.$refs.addressBarangay.reset();
                    this.$refs.addressCity.reset();
                    this.$refs.addressProvince.reset();
                }, 50);

            }
        },
        async getCountry() {
            await this.fetchCountries(); 
        },
        async getCities() {
            if(this.user.roleName != 'Super Admin') return;
            if(this.address.countryId == 169)
            {
                await this.fetchCities({ 
                    provinceId: this.address.provinceId, 
                    storeCount: 0
                }).then(data => {
                    this.citiesData = data;
                });
            }
        },
        async getBarangays() {
            if(this.user.roleName != 'Super Admin') return;
            if(this.address.countryId == 169)
            {
                await this.fetchBarangays({
                    cityId: this.address.cityId,
                    storeCount: 0
                }).then(data => {
                    this.barangaysData = data;
                });
            }
        },
        async getProvinces() {
            if(this.user.roleName != 'Super Admin') return;
            if(this.address.countryId == 169)
            {
                await this.fetchProvinces({
                    regionId: this.address.regionId,
                    storeCount: 0  
                }).then(data => {
                    this.provincesData = data;
                });
            }
        },
        updateProfileObjectData() {
            this.user.logo.filename = null;
            this.user.logo.type = null;
            this.user.logo.base64 = null;
            this.user.profileKey = null;
            this.user.profileSrc = require('@/assets/images/img-profile-placeholder.png');
        },
        updateBizLogoObjectData() {
            this.organization.logo.filename = null;
            this.organization.logo.type = null;
            this.organization.logo.base64 = null;
            this.organization.logoKey = null;
            this.organization.logoSrc = require('@/assets/images/img-placeholder.png');
        },
      
        async updateUserProfileFunc() {

            if(this.isPageReloading) return;
            // Lets revalidate the forms 
            const validationResult = await this.$refs.observer.validate();
            
            // If theres validation error now we'll scroll the view to the error (User friend leetsg)
            if (!validationResult) {

                // This will scroll to errors 
                this.$nextTick(() => {
                    // We querySelect with .is-invalid class 
                    document.querySelector('.is-invalid').scrollIntoView({block: "center", behavior: "smooth"})
                });
                return;
            }

            let 
                _country =      this.address.countryId != null ? (this.countries.find((country) => country.countryId === this.address.countryId)).countryName : '--',
                _region =       this.address.regionId != null ? (this.regionsData.find((region) => region.regionId === this.address.regionId)).regionName : '--',
                _province =     this.address.provinceId != null ? (this.provincesData.find((province) => province.provinceId === this.address.provinceId)).provinceName : '--',
                _city =         this.address.cityId != null ? (this.citiesData.find((city) => city.cityId === this.address.cityId)).cityName : '--',
                _barangay =     this.address.barangayId != null ? (this.barangaysData.find((barangay) => barangay.brgyId === this.address.barangayId)).brgyName : '--',
                _street =       this.address.street ?? '--'
            ;

            if (this.organization.logo.base64) {
                await this.uploadBusinessLogo(
                        Object.assign({cognitoSub: this.currentUser.cognitoSub},
                        this.organization.logo
                    )
                ).then(result => {
                    this.organization.logoKey = result;
                });
            }
            if(this.user.logo.base64)
            {
                await this.uploadProfilePicture(
                        Object.assign({cognitoSub: this.currentUser.cognitoSub},
                        this.user.logo
                    )
                ).then(result => {
                    this.user.profileKey = result;
                });
            }
            const parameters = {
                userName: this.user.name,
                userRoleId: this.user.roleId,
                userMobileNumber: this.user.phone_number ?? '',
                userMobileIsChanged: !(this.user.phone_number_checker == this.user.phone_number),
                userEmailAddress: this.userData.user.email,
                userProfileKey: this.user.profileKey ?? '',
                orgLogoKey: this.organization.logoKey ?? '',
                orgName: this.organization.name,
                orgType: this.bizTypeOption.others ? (this.organization.businessType  ?? '') : (this.bizTypeOption.value ?? '') ,
                orgStartHour: this.organization.startHour ?? '09:00',
                orgEndHour: this.organization.endHour ?? '18:00',
                orgMobileNumber: this.organization.contact_number ?? '',
                orgCountry: _country,
                orgRegion: _region,
                orgProvince: _province,
                orgCity: _city,
                orgBarangay: _barangay,
                orgStreet: _street,
            }
            console.log("Update parameters: ", parameters);
            await this.updateUserProfile(parameters).then(async result => {

                if(result.status == 'ok')
                {
                    // // Scroll to top when success.
                    // this.$nextTick(() => {
                    //     this.$refs.observer.reset();
                    //     window.scrollTo({
                    //         top: 0,
                    //         behavior: "smooth",
                    //     });
                    // });
                    // Update this for checker purposes so it wont spam change cognito mobile number of the user 
                    this.user.phone_number_checker = this.user.phone_number;
                    

                    // We need to update the userData from local storage
                    // Fetch the Data
                    let userData = JSON.parse(localStorage.getItem('userData')); 

                    // Update the mobile and name of the user 
                    userData.mobile = this.user.phone_number; 
                    userData.name = this.user.name;

                    // Save the changes.
                    store.commit('auth/SET_CURRENT_USER', userData);
                    let toastData = {
                        type: "success" ,
                        title: "Success!" ,
                        message: result.message
                    }
                    this.$router.push({ name: 'profile' , query: { toastData: toastData } });
                }
                else this.$toast.showToast(result.status == 'ok' ? "success" : "danger", result.status == 'ok' ? "Success!" : "Failed!", result.status == 'ok' ? result.message : "Profile update unsuccessful. Please try again later.");
                

            }).catch(async error => {
                console.log(error);
                
                this.$toast.showToast('danger', "Failed!", "Profile update unsuccessful. Please try again later.");
            });
        },
        async signedUrl(key, level) {
            return await Storage.get(key, { level: level });
        },
    },
    components: {
        Layout,
        ProfileImageUploader,
        PageHeader,
        ImageUploader
    },
    async mounted() {
        await this.changeBreadCrumb({
            breadCrumbs: [
                { text: "User Profile", to: { name: "profile" } },
                { text: 'Edit Profile', to: { name: 'edit-profile'} }
            ],
        });
        await this.getCountry();
        // await this.getRolesList();
        // Preload the User Profile
        await this.fetchUserProfile().then( async () => {
            // Fetch Users
            this.user.name = this.userData.user.name;
            this.user.email = this.userData.user.email;
            this.user.phone_number = this.userData.user.mobile;
            this.user.phone_number_checker = this.user.phone_number;
            this.user.profileKey = this.userData.user.profile;
            this.user.profileSrc = (this.userData.user.profile != null && this.userData.user.profile != '') ? await this.signedUrl(this.userData.user.profile, "protected") : require('@/assets/images/img-profile-placeholder.png'); 
            this.preloadProfileImageKey++; // reload the component
            this.customRoleList.push({
                name: this.userData.user.roleName,
                id: this.userData.user.role
            });

            this.user.roleId = (this.customRoleList.find((role) => role.name === this.userData.user.roleName)).id;
            this.user.roleName = this.userData.user.roleName;

            // Fetch Org
            let isBizTypeExisting = false;
            this.bizTypeOption.value = this.userData.org.type;
            this.businessTypeOptions.forEach(option => {
                if(option.value !=null && this.bizTypeOption.value != null && this.bizTypeOption.value != '' && this.bizTypeOption.value == option.value)
                {
                    isBizTypeExisting = true;
                }
            });

            if(!isBizTypeExisting) 
            {
                if(this.bizTypeOption.value != null && this.bizTypeOption.value != '')
                {
                    this.bizTypeOption.value = 'Others'
                    this.bizTypeOption.others = true;
                    this.organization.businessType = this.userData.org.type;
                }
                else 
                {
                    this.organization.businessType = null;
                    this.bizTypeOption.value = null;
                }
            }
            
            this.organization.startHour = (this.userData.org.startHour == null || this.userData.org.startHour == '') ? '09:00' : this.userData.org.startHour;
            this.organization.endHour = (this.userData.org.endHour == null || this.userData.org.endHour == '') ? '18:00' : this.userData.org.endHour;
            this.organization.businessHours = `${this.userData.org.startHour} - ${this.userData.org.endHour}`;

            this.organization.name = this.userData.org.name;
            this.organization.contact_number = this.userData.org.contactNumber;
            this.organization.logoKey = this.userData.org.logoKey;
            this.organization.logoSrc = this.userData.org.logoKey != null && this.userData.org.logoKey != '' ?  await this.signedUrl(this.userData.org.logoKey, "public") : require('@/assets/images/img-placeholder.png');

            this.$emit('dynamicColor'); // regenerate the dynamic color 

            
            // Fetch Org Addresses
            if(this.user.roleName == 'Super Admin')
            {
                this.address.countryId = (this.userData.org.country != null && this.userData.org.country != "--") ? (this.countries.find((country) => country.countryName === this.userData.org.country)).countryId : null;
                if(this.address.countryId == 169)
                {
                    await this.getRegions();
                    this.address.regionId = (this.userData.org.region != null && this.userData.org.region != "--") ? (this.regionsData.find((region) => region.regionName === this.userData.org.region)).regionId : null;

                    await this.getProvinces();
                    this.address.provinceId = (this.userData.org.province != null && this.userData.org.province != "--") ? (this.provincesData.find((province) => province.provinceName === this.userData.org.province)).provinceId : null;
                    
                    await this.getCities();
                    this.address.cityId = (this.userData.org.city != null && this.userData.org.city != "--") ? (this.citiesData.find((city) => city.cityName === this.userData.org.city)).cityId : null;

                    await this.getBarangays();
                    this.address.barangayId = (this.userData.org.barangay != null && this.userData.org.barangay != "--") ? (this.barangaysData.find((barangay) => barangay.brgyName === this.userData.org.barangay)).brgyId : null;

                } 
            
                this.address.street = this.userData.org.street;
            }
            

            this.$nextTick(() => {
                this.$refs.observer.reset();
            });

            this.isPageReloading = false;
            // this.address.countryIso = this.address.countryIso != null && this.address.countryIso != '' ? (this.countries.find((country) => country.countryId === this.address.countryId)).iso : 'PH'
            // this.address.countryIso3 = this.address.countryIso != null && this.address.countryIso != '' ? (this.countries.find((country) => country.countryId === this.address.countryId)).iso3 : 'PHL'
            // this.$ref.orgMobileNumber.valid();
            // this.$ref.userMobileNumber.valid();
            
        });
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="breadCrumbs" :prev="{name:'profile',params:{}}"/>
        <p>The user profile is a collection of settings and information associated with you and your business. It includes critical information such as user details, business details, and business address.</p>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-3 col-md-3 col-lg-3 profile-uploader-col">
                        <profile-image-uploader
                                :key="preloadProfileImageKey"
                                :profileImageSrc="user.profileSrc"
                                v-model="user.logo"
                                label="Profile Photo"
                                :isRequired="false"
                                @trigger-method="updateProfileObjectData"
                            />
                    </div>
                    <div class="col-sm-8 col-md-8 col-lg-8">
                        <ValidationObserver v-slot="{ handleSubmit, reset } " ref="observer">
                            <b-form ref="companyForm" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="reset">
                                <div class="row">
                                    <h5 class="mb-4">
                                        <b>Users Details</b>
                                    </h5>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Full Name <span class="red">*</span>
                                            </label>
                                            <validation-provider name="full name" rules="required" v-slot="validationContext">
                                                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter Full Name" v-model="user.name" trim></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Role <span class="red">*</span>
                                            </label>
                                            <validation-provider ref="roleType" name="role type" rules="required" v-slot="validationContext">
                                                <b-form-select :state="getValidationState(validationContext)" class="form-select" v-model="user.roleId" :options="roleOptions" disabled></b-form-select>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <h5 class="mb-4">
                                        <b>Contact Info</b>
                                    </h5>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Mobile Number <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider ref="userMobileNumber" name="user mobile number" rules="" v-slot="validationContext">
                                                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter Mobile Number (ex. 09171113333)" v-model="user.phone_number" trim></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6 mb-0 pb-0">
                                        <b-form-group class="mb-4">
                                            <label>Email Address <span class="red">*</span>
                                            </label>
                                            <validation-provider name="email address" rules="required|email" v-slot="validationContext">
                                                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter Email Address" v-model="user.email" trim disabled></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                            <span class="contact-support-class">To change your email, please <a href="#" onclick="FB.CustomerChat.showDialog()">Contact Support</a></span>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div v-if="user.roleName == 'Super Admin'">
                                    <div class="row">
                                    <hr>
                                    <h5 class="mb-4 mt-2">
                                        <b>Business Details</b>
                                    </h5>
                                    <div class="mb-4">
                                        <label>Business Logo <span class="optional">(Optional)</span>
                                        </label>
                                        <image-uploader class="me-4" uploadText="Upload your business logo here." :imageSrc="organization.logoSrc" v-model="organization.logo" @trigger-method="updateBizLogoObjectData" :showDeleteButton="true" />
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Business Name <span class="red">*</span>
                                            </label>
                                            <validation-provider name="business name" rules="required" v-slot="validationContext">
                                                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter Business Name" v-model="organization.name" trim></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-1">
                                            <label>Business Type <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider ref="bizType" name="business type" rules="" v-slot="validationContext">
                                                <b-form-select :state="getValidationState(validationContext)" class="form-select" v-model="bizTypeOption.value" :options="businessTypeOptions"></b-form-select>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                        <b-form-group class="mb-4" v-if="bizTypeOption.others">
                                            <label class="biz-type-others-class px-2">For "Others," please specify your business type below.
                                            </label>
                                            <validation-provider name="business type others" rules="" v-slot="validationContext">
                                                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter your Business Type" v-model="organization.businessType" trim></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6" @focusout="onBusinessHoursFocusOut">
                                        <b-form-group class="mb-4 biz-hours">
                                            <label>Business Hours <span class="optional">(Optional)</span></label>
                                            <validation-provider name="Business Hours" rules="" v-slot="validationContext">
                                                <b-form-input
                                                :state="getValidationState(validationContext)"
                                                placeholder="5:00 AM - 6:00 PM"
                                                v-model="organization.businessHours"
                                                :readonly="true"
                                                @focus="showTimers = true"
                                                trim
                                                ></b-form-input>
                                                <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                            </b-form-group>

                                            <b-form-group class="mb-4" v-if="showTimers">
                                            <b-row class="biz-timer-class">
                                                <b-col>
                                                <span>Opening</span>
                                                <validation-provider name="business start hour" rules="" v-slot="validationContext">
                                                    <b-form-input type="time" :state="getValidationState(validationContext)" v-model="organization.startHour" trim></b-form-input>
                                                    <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                    </b-form-invalid-feedback>
                                                </validation-provider>
                                                </b-col>
                                                <b-col>
                                                <span>Closing</span>
                                                <validation-provider name="business end hour" rules="" v-slot="validationContext">
                                                    <b-form-input type="time" :state="getValidationState(validationContext)" v-model="organization.endHour" trim></b-form-input>
                                                    <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                    </b-form-invalid-feedback>
                                                </validation-provider>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Business Contact Number <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider ref="orgMobileNumber" name="business contact number" :rules="dynMobileRule" v-slot="validationContext">
                                                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter Contact Number" v-model="organization.contact_number" trim></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <h5 class="mb-4">
                                        <b>Business Address</b>
                                    </h5>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Country <span class="optional">(Optional)</span>
                                            </label>
                                            
                                            <validation-provider ref="addressCountry" name="business country" rules="" v-slot="validationContext">
                                                <b-form-select :state="getValidationState(validationContext)" v-model="address.countryId" placeholder="Select Country" class="form-select" :options="countryOptions" @change="getRegions">
                                                </b-form-select>
                                                
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Region <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider ref="addressRegion" name="business region" rules="" v-slot="validationContext">
                                                <b-form-select :state="getValidationState(validationContext)" :disabled="regionOptions.length == 1" v-model="address.regionId" placeholder="Select Province" class="form-select" :options="regionOptions" @change="getProvinces"></b-form-select>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>State / Province <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider ref="addressProvince" name="business province" rules="" v-slot="validationContext">
                                                <b-form-select :state="getValidationState(validationContext)" :disabled="provinceOptions.length == 1" v-model="address.provinceId" placeholder="Select State / Province" class="form-select" :options="provinceOptions" @change="getCities"></b-form-select>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>City <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider ref="addressCity" name="business city" rules="" v-slot="validationContext">
                                                <b-form-select :state="getValidationState(validationContext)" :disabled="cityOptions.length == 1" v-model="address.cityId" placeholder="Select City" class="form-select" :options="cityOptions" @change="getBarangays"></b-form-select>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Barangay <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider ref="addressBarangay" name="business barangay" rules="" v-slot="validationContext">
                                                <b-form-select :state="getValidationState(validationContext)" :disabled="barangayOptions.length == 1" v-model="address.barangayId" placeholder="Select Barangay" class="form-select" :options="barangayOptions"></b-form-select>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group class="mb-4">
                                            <label>Building No. / Street Name / District <span class="optional">(Optional)</span>
                                            </label>
                                            <validation-provider name="business street address" rules="" v-slot="validationContext">
                                                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter Street Address" v-model="address.street" trim></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                </div>
                                </div>
                            </b-form>
                            <div class="row">
                                <div class="col-sm-12 col-md-7 col-lg-7 mt-3">
                                    <router-link to="/pages/profile/edit/password">Change Your Password</router-link>
                                </div>
                                <div class="col-sm-12 col-md-5 col-lg-5 mt-2 text-end"> 
                                    <div class="d-flex justify-content-md-end justify-content-lg-end">
                                        <router-link to="/pages/profile">
                                            <button class="btn btn-secondary me-3" type="button">
                                                Cancel
                                            </button>
                                        </router-link>
                                        <button class="btn btn-primary" type="button" @click="updateUserProfileFunc">
                                            <div v-if="!isPageReloading">
                                                Save Changes
                                            </div>
                                            <div v-if="isPageReloading">
                                                <i class="spinner-grow spinner-grow-sm px-2"></i>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.pointer {
    cursor: pointer;
}

.card-active {
    background-color: #ffa549 !important;
}

.card-img-back {
    background-color: #f1f0f9 !important;
}
.red {
    color: red;
}
.biz-timer-class {
    color:grey;
    padding: 0px;
    font-size: 10px;
}
.bi-chevron-down::before {
  content: "\e5ec"; /* Unicode character for chevron-down */
  font-family: "Bootstrap Icons";
  display: block;
  position: absolute;
  top: calc(50% - 0.75rem); /* Vertically center the icon */
  right: 1rem;
  pointer-events: none;
}


.card {
  display: flex;
}
.profile-uploader-col {
    width: 280px; 
}
.contact-support-class {
    color: #4B4B4B;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
}
.biz-type-others-class {
    color: #4B4B4B;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
}
.contact-support-class a{
    text-decoration: underline !important;
}   

/* 
@media (max-width: 991px) { 
   .card {
    flex-direction: column; 
  }

  .profile-uploader-col {
    width: 100%; 
    text-align: center; 
  }

  .col-content {
    width: 100%; 
  }
  .col-md-6 {
    width: 100%; 
  }
} */

</style>
